import { useQuery } from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { ListCandidatesParams, Candidate } from '../types/candidate.types';

interface UseCandidatesReturn {
  candidates: Candidate[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useCandidates(params: ListCandidatesParams): UseCandidatesReturn {
  const query = useQuery({
    queryKey: ['candidates', params],
    queryFn: () => candidateService.listCandidates(params),
    enabled: !!params.companyId,
  });

  return {
    candidates: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
